/**
 * Typography tokens — Famílias de fontes centralizadas
 *
 * Evita que cada componente declare sua própria stack de fontes.
 * Importar daqui em vez de hardcodar fontFamily inline.
 */

export const fontFamilyMono = [
  '"JetBrains Mono"',
  '"Fira Code"',
  '"Roboto Mono"',
  '"SFMono-Regular"',
  'Consolas',
  '"Liberation Mono"',
  'Menlo',
  'monospace',
].join(', ');

const schibsted = [
  '"Schibsted Grotesk"',
  '"Segoe UI"',
  '"Helvetica Neue"',
  "Arial",
  "sans-serif",
].join(", ");

export const fontFamilyDisplay = schibsted;
export const fontFamilyUI = schibsted;
